module.exports = __webpack_public_path__ + "static/media/appointment_scheduling.5b9672a6.svg";